import { ReactNode } from 'react'

import { Form } from 'factorial-form'

abstract class ContractFlowStep {
  private _title: string
  private _component: ReactNode
  private _description?: string

  constructor(title: string, component: ReactNode, description?: string) {
    this._title = title
    this._component = component
    this._description = description
  }

  get title(): string {
    return this._title
  }

  get component(): ReactNode {
    return this._component
  }

  get description(): string | undefined {
    return this._description
  }

  abstract trackNext(form: Form, step: number): void
  abstract trackBack(form: Form, step: number): void
  abstract trackSubmit(form: Form): void
  abstract trackExit(step: number): void
}

export default ContractFlowStep
